<app-side-menu>
  <router-outlet></router-outlet>
</app-side-menu>
